import { Pill } from "@dashboard/components/Pill/Pill";
import { type AtticApiKeyStatusEnum } from "@dashboard/graphql";
import { useIntl } from "react-intl";

import { accessMessages, statusMessages } from "../../messages";
import { getStatusPillColor } from "../../utils";

export const AtticApiKeyStatusPill = ({ status }: { status: AtticApiKeyStatusEnum }) => {
  const intl = useIntl();

  return (
    <Pill
      color={getStatusPillColor(status)}
      label={intl.formatMessage(statusMessages[status])}
      data-test-id="attic-api-key-status"
    />
  );
};

/** Beside the status on a key refused on every mutation. */
export const AtticApiKeyReadOnlyPill = () => {
  const intl = useIntl();

  return (
    <Pill
      color="info"
      label={intl.formatMessage(accessMessages.readOnly)}
      data-test-id="attic-api-key-read-only-pill"
    />
  );
};

export default AtticApiKeyStatusPill;
